import {Pointer} from "@aldea/sdk";

export const COIN_CLASS_PTR = Pointer.fromString("0000000000000000000000000000000000000000000000000000000000000000_0")
export const PATH_PREFIX = "/0/"
export const MAX_GAP_SIZE = 20
